import { render } from "./ShipManpower.vue?vue&type=template&id=2f8dc814&scoped=true"
import script from "./ShipManpower.vue?vue&type=script&lang=js"
export * from "./ShipManpower.vue?vue&type=script&lang=js"

import "./ShipManpower.vue?vue&type=style&index=0&id=2f8dc814&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8dc814"]])

export default __exports__